import { IRoute } from '@config/routes/interfaces';
import { AdminPaths, LoginPaths, PrivatePaths, PublicPaths } from '@config/routes/paths';

const combinedPaths = [...AdminPaths, ...PrivatePaths, ...LoginPaths, ...PublicPaths];

export const AllPaths = {
    path: (key: string, params?: any) => {
        const route = combinedPaths.find((r: IRoute) => r.key === key);

        if (route) {
            if (!params) return route.path;

            let { path } = route;
            Object.keys(params).forEach((k: string) => {
                path = path.replace(`:${k}`, (params[k] || '').toString());
            });

            return path;
        }
        return null;
    },
    key: (route: string) => {
        return combinedPaths.find((r: IRoute) => r.path === route)?.key;
    },
};
